import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { openAccountSettings } from '~/lib/stores/accountSettings';

/**
 * /settings/billing — the address Dunea Desktop and Work open for "Manage on
 * website". Settings is a modal here, not a page, so this opens it on Plan and
 * lands on home underneath.
 */
export default function SettingsBillingPage() {
  useEffect(() => {
    openAccountSettings('plans', 'desktop');
  }, []);

  return <Navigate to="/" replace />;
}
